import { motion } from "framer-motion";
import { Reveal } from "./anim";
import { IMAGES } from "./config";

const shots = [
  { src: IMAGES.front, label: "L'excellence en mouvement", span: "md:col-span-8", h: "h-72 md:h-[26rem]" },
  { src: IMAGES.standing, label: "Chaque détail a son importance", span: "md:col-span-4", h: "h-72 md:h-[26rem]" },
  { src: IMAGES.interior, label: "Le silence comme signature", span: "md:col-span-5", h: "h-72 md:h-80" },
  { src: IMAGES.seats, label: "Prenez place. Nous nous occupons du reste.", span: "md:col-span-7", h: "h-72 md:h-80" },
];

const Fleet = () => (
  <section id="flotte" data-testid="fleet-section" className="relative py-28 lg:py-40">
    <div className="pointer-events-none absolute inset-0 spotlight" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <div className="mb-16 max-w-2xl">
          <p className="mb-4 text-xs uppercase tracking-[0.3em] text-rose">La flotte</p>
          <h2 className="font-serif text-4xl leading-tight tracking-tight sm:text-6xl text-blush">
            Une berline d'exception, entretenue avec soin.
          </h2>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:gap-5">
        {shots.map((s, i) => (
          <Reveal key={i} delay={i * 0.06} className={s.span}>
            <motion.div className={`group relative overflow-hidden rounded-2xl ${s.h}`}>
              <img
                src={s.src}
                alt={s.label}
                className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
              <span className="absolute bottom-5 left-5 font-serif text-2xl italic text-blush">{s.label}</span>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Fleet;
